<div class="bk-admin__container">
    <admin-nav>

    </admin-nav>
</div>